var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form archive-popup"
  }, [_c('div', {
    staticClass: "content-form-popup archive-popup-content"
  }, [_c('div', {
    staticClass: "archive-popup-header"
  }, [_c('button', {
    staticClass: "archive-close",
    attrs: {
      "type": "button",
      "aria-label": "Zavrieť"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _vm._m(0)]), _c('div', {
    staticClass: "archive-choice-list"
  }, _vm._l(_vm.primaryChoices, function (choice) {
    return _c('button', {
      key: choice.value,
      staticClass: "archive-choice",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.selectReason(choice);
        }
      }
    }, [_c('span', {
      staticClass: "archive-choice-icon",
      "class": "is-".concat(choice.tone)
    }, [_vm._v(_vm._s(choice.icon))]), _c('span', {
      staticClass: "archive-choice-copy"
    }, [_c('strong', [_vm._v(_vm._s(choice.label))]), _c('small', [_vm._v(_vm._s(choice.description))])]), _c('span', {
      staticClass: "archive-choice-arrow"
    }, [_vm._v(_vm._s(choice.value === 'other_failure' ? '›' : '✓'))])]);
  }), 0)])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('span', {
    staticClass: "archive-kicker"
  }, [_vm._v("Archivácia klienta")]), _c('h2', [_vm._v("Prečo službu nevyužil?")]), _c('p', [_vm._v("Vyberte hlavný obchodný dôvod. Pomôže nám presnejšie vyhodnocovať kvalitu leadov.")])]);

}]

export { render, staticRenderFns }